import type { IMaintenanceListResponse } from '@/store/api/maintenanceApi';
import { isTicketCompleted } from './ticketStatus';

export interface SplitMaintenanceTickets {
  open: IMaintenanceListResponse[];
  closed: IMaintenanceListResponse[];
}

/**
 * Status-based open/closed split. A ticket is closed when its mapped status is
 * terminal (completed OR cancelled) — NOT when `completedOn` is set: Yardi only
 * stamps `completedOn` for "Work Completed", which stranded cancelled tickets
 * in the Open tab forever.
 */
export const splitMaintenanceTickets = (
  tickets: IMaintenanceListResponse[],
): SplitMaintenanceTickets => {
  const open: IMaintenanceListResponse[] = [];
  const closed: IMaintenanceListResponse[] = [];
  for (const ticket of tickets) {
    (isTicketCompleted(ticket) ? closed : open).push(ticket);
  }
  return { open, closed };
};
